import { Stack, Typography, useTheme } from "@mui/material";

import { Strings } from "@app/constants";
import { useResponsive } from "@app/hooks";

const FooterPolicies = () => {
  const theme = useTheme(); 
   const isMobile = useResponsive("down", "md");

  return (
    <Stack spacing={1}>
      <Typography
        fontWeight="400"
        color={theme.palette.common.white}
        fontSize={"10"}
        sx={{ cursor: "pointer" }}
      >
        {Strings.footer.privacyPolicy}
      </Typography>
      <Typography
        fontWeight="400"
        color={theme.palette.common.white}
        fontSize={"10"}
        sx={{ cursor: "pointer" }}
      >
        {Strings.footer.termsAndCondition}
      </Typography>
    </Stack>
  );
};

export { FooterPolicies };
